/**
 * Status is derived, never stored.
 *
 * The tempting shortcut is an `obligations.status` column updated whenever a
 * payment lands. It is also how a demo ends up showing "Pagado" next to a
 * balance of B/. 15 — one write that did not happen, and the screen contradicts
 * itself in front of the person you are trying to convince. The balance is the
 * only fact; the label is a function of it and today's date.
 */
import { daysBetween } from "./period.js";
export function deriveStatus({ amountDueCents, amountPaidCents, dueDate, today, }) {
    const outstanding = amountDueCents - amountPaidCents;
    if (outstanding <= 0)
        return "PAID";
    // Overdue wins over partial: money that is late is the thing the owner has
    // to act on, and "Pago parcial" would hide that behind a softer word.
    if (dueDate < today)
        return "OVERDUE";
    if (amountPaidCents > 0)
        return "PARTIAL";
    return "PENDING";
}
export function outstandingCents(amountDueCents, amountPaidCents) {
    return Math.max(0, amountDueCents - amountPaidCents);
}
const LABELS = {
    PAID: "Pagado",
    PARTIAL: "Pago parcial",
    OVERDUE: "Vencido",
    PENDING: "Pendiente",
};
const TONES = {
    PAID: "paid",
    PARTIAL: "warn",
    OVERDUE: "danger",
    PENDING: "warn",
};
export function statusLabel(status) {
    return LABELS[status];
}
export function statusTone(status) {
    return TONES[status];
}
/**
 * The second line of a status chip: "Vencido · 8 días", "Vence en 3 días".
 *
 * Days matter more than the date itself. "Vencido" alone does not tell the
 * owner whether to send a friendly nudge or to call.
 */
export function statusDetail(status, dueDate, today) {
    if (status === "PAID")
        return null;
    const days = daysBetween(dueDate, today);
    if (days > 0)
        return days === 1 ? "1 día" : `${days} días`;
    if (days === 0)
        return "Vence hoy";
    return days === -1 ? "Vence mañana" : `Vence en ${-days} días`;
}
